<template lang="pug">
	.dropdown-menu.dropdown-menu-right(v-pseudo-modal="'domain-actions-dropdown'" :style="{top: `${topY}px`, left: `${leftX}px`}")
		.dropdown-header.text-center
			strong {{domain}}
		//.dropdown-item(@click="openJsonEditor()")
			i.fa.fa-pencil
			span Edit JSON
		.dropdown-item(@click="downloadJson()")
			i.fa.fa-download
			span Download JSON
		.dropdown-item(@click="uploadJson()")
			i.fa.fa-upload
			span Upload JSON
		.dropdown-item(@click="openJsonOnCdn")
			i.fa.fa-external-link
			span See JSON on CDN
		//.dropdown-item(@click="openCssEditor()")
			i.fa.fa-pencil
			span Edit CSS
		.dropdown-item(@click="downloadCss()")
			i.fa.fa-download
			span Download CSS
		.dropdown-item(@click="uploadCss()")
			i.fa.fa-upload
			span Upload CSS
		.dropdown-item(@click="openCssOnCdn")
			i.fa.fa-external-link
			span See CSS on CDN
		.dropdown-item(@click="removeDomain")
			i.fa.fa-trash
			span Remove domain
</template>

<script>

import Screen 				from './../../mixins/screen';
import {Template} from "@/services/Template";
import SetupSettings from "@/settings/settings.json";

export default {
	name: "ActionsDomain",
	mixins: [Screen],
	screen: {
		updateOn: [],
		events: {
			"Show Actions Domain": function (domain, target) {
				this.showed = true;
				this.domain = domain;
				const rect = target.getBoundingClientRect();
				this.setPosition(rect.left - 200, rect.top);
			}
		}
	},
	props: [],
	data() {

		this.topY = 0;
		this.leftX = 0;
		this.domain = '';

		return {
			showed: true,
			domain: ''
		};

	},
	methods: {

		collectData() {

		},

		downloadCss() {
			const domain = this.domain;
			Template.downloadExtraStyles(domain);

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();
		},
		downloadJson() {
			const domain = this.domain;
			Template.downloadJson(domain);

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();
		},
		openJsonEditor() {

			Broadcast.call("Show Json Editor", [this.domain]);

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},
		openCssEditor() {

			Broadcast.call("Show Css Editor", [this.domain]);

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},
		uploadJson() {

			const domain = this.domain;
			if (!domain) return;
			if (domain === 'websites') return;

			let input = document.createElement('input');
			input.type = 'file';
			input.classList.add('css-input');
			input.accept = 'application/JSON, text/plain';

			document.body.appendChild(input);

			input.addEventListener('change', e => {

				let file = e.target.files[0];

				Template.uploadJson(file, domain);

				document.body.removeChild(input);

			});

			input.click();

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},

		uploadCss() {

			const domain = this.domain;
			if (!domain) return;
			if (domain === 'extra-styles') return;

			let input = document.createElement('input');
			input.type = 'file';
			input.classList.add('css-input');
			input.accept = '.css, .js, text/css, application/x-javascript';

			document.body.appendChild(input);

			input.addEventListener('change', e => {

				let file = e.target.files[0];

				Template.uploadExtraStyles(file, domain);

				document.body.removeChild(input);

			});

			input.click();

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},

		removeDomain() {

			const domain = this.domain;

			if (!domain || domain === 'extra-styles') return;

			Broadcast.call("Show Actions Remove Website Domain", [domain]);

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},

		openJsonOnCdn() {

			const domain = this.domain;
			let cdnFolder = 'prvk-websites';
			if (SetupSettings.domain === 'localhost') cdnFolder += '-temp';
			else if (SetupSettings.domain === 'mraid.io') cdnFolder += '-mraid';

			let fileName = domain ? (domain + '.json') : 'websites.json';

			const url = `${Server.Config['amazon-s3-cdn-url']}${cdnFolder}/${fileName}`;

			window.open(url, '_blank');

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},

		openCssOnCdn() {

			const domain = this.domain;
			let cdnFolder = 'prvk-websites';
			if (SetupSettings.domain === 'localhost') cdnFolder += '-temp';
			else if (SetupSettings.domain === 'mraid.io') cdnFolder += '-mraid';

			let fileName = domain ? (domain + '.css') : 'extra-styles.css';

			const url = `${Server.Config['amazon-s3-cdn-url']}${cdnFolder}/${fileName}`;

			window.open(url, '_blank');

			Broadcast.call("Pseudo Modal Hide", ["domain-actions-dropdown"]);
			this.hide();

		},

		setPosition(x, y) {
			this.topY = Math.min(y, document.documentElement.clientHeight - this.$el.offsetHeight);
			this.leftX = x;

			this.$forceUpdate();
		},

	}
}

</script>
